import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const getProducts = (category) =>
  api.get("/products", { params: category ? { category } : {} }).then((r) => r.data);

export const getCategories = () => api.get("/products/categories").then((r) => r.data);

export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);

export const getBlogPosts = () => api.get("/blog").then((r) => r.data);

export const getBlogPost = (slug) => api.get(`/blog/${slug}`).then((r) => r.data);

export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);

export const sendContact = (payload) => api.post("/contact", payload).then((r) => r.data);

export const requestStockNotification = (payload) =>
  api.post("/stock-requests", payload).then((r) => r.data);

export const trackOrder = (payload) => api.post("/orders/track", payload).then((r) => r.data);

export const createCheckoutSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

export default api;
